import illusUpgradeSuccess from "images/illus_upgrade_success.svg";
import iconComunity from "images/icon_community.svg";
import iconLock from "images/icon_lock.svg";
import { useEffect, useTransition } from "react";
import { useTranslation } from "react-i18next";
import { zoomState } from "state";
import { useRecoilValue } from "recoil";
import ZJSBridge from "zalo-js-bridge";

const Success: React.FC<{}> = (props) => {
  const { t } = useTranslation();
  const zoom = useRecoilValue(zoomState);
  useEffect(() => {
    document.title = t("lp.header.title");
  }, []);

  const closeWebview = () => {
    ZJSBridge.H5.closeWebview();
  };

  return (
    <div className="pt-12 px-6 h-screen flex flex-col items-center self-stretch justify-between text-size-adjust-auto">
      <div className="flex flex-col" style={{ zoom: zoom }}>
        <div className="flex flex-col items-center self-stretch">
          <img className="w-[200px] h-40" src={illusUpgradeSuccess} alt="" />
          <div className="mt-4 text-center font-medium text-[22px] leading-[26px]">
            {t("success.header.title")}
          </div>
        </div>
        <div className="mt-6 pl-2 flex flex-col items-start self-stretch max-h-[500px]">
          <div className="flex item-start self-stretch">
            <img className="w-6 h-6" src={iconComunity} alt="" />
            <div className="ml-6 flex flex-col items-start flex-1">
              <div className="font-medium text-[16px] leading-[22px]">
                {t("success.benefit.member_size.title")}
              </div>
              <div
                className="mt-0.5 font-normal text-[15px] leading-[20px]"
                style={{ color: "#6F7071" }}
              >
                {t("success.benefit.member_size.sub_title")}
              </div>
            </div>
          </div>
          <div className="mt-4 flex item-start self-stretch">
            <img className="w-6 h-6" src={iconLock} alt="" />
            <div className="ml-6 flex flex-col items-start flex-1">
              <div className="font-medium text-[16px] leading-[22px]">
                {t("success.benefit.privacy.title")}
              </div>
              <div
                className="mt-0.5 font-normal text-[15px] leading-[20px]"
                style={{ color: "#6F7071" }}
              >
                <div className="font-normal text-[15px] leading-[20px]">
                  {t("success.benefit.privacy.sub_title")}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 flex flex-col items-center self-stretch">
            <a
              className="font-medium text-[15px] leading-[20px]"
              href="https://help.zalo.me/huong-dan/chuyen-muc/tro-chuyen-nhom/tro-chuyen-cong-dong-them-ket-noi-them-quyen-rieng-tu/"
              style={{ color: "#0068FF" }}
            >
              {t("success.benefit.learn_more")}
            </a>
          </div>
        </div>
      </div>
      <div
        className="mt-2 mb-6 flex flex-col items-start self-stretch bg-blue-600 rounded-full"
        style={{ zoom: zoom }}
      >
        <div
          className="flex flex-col px-6 py-3 justify-center items-center self-stretch"
          onClick={closeWebview}
        >
          <div className="flex items-center h-6 font-medium text-[15px] leading-[20px] text-white">
            {t("button.close")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
